import { useCallback, useEffect, useState } from "react";

// Light/dark theme — class-based (.dark on <html>), persisted, FOUC-safe.
// The initial class is applied by an inline script in public/index.html before
// React mounts; this hook just keeps runtime state + localStorage in sync.
const KEY = "ek-theme";

function currentTheme() {
  if (typeof document === "undefined") return "light";
  return document.documentElement.classList.contains("dark") ? "dark" : "light";
}

export function useTheme() {
  const [theme, setThemeState] = useState(currentTheme);

  const apply = useCallback((t) => {
    const dark = t === "dark";
    document.documentElement.classList.toggle("dark", dark);
    document.documentElement.style.colorScheme = dark ? "dark" : "light";
    try { localStorage.setItem(KEY, t); } catch (e) { /* private mode */ }
    setThemeState(t);
  }, []);

  const toggle = useCallback(() => apply(currentTheme() === "dark" ? "light" : "dark"), [apply]);

  useEffect(() => { setThemeState(currentTheme()); }, []);

  return { theme, toggle, setTheme: apply, isDark: theme === "dark" };
}
